'use client';

// components/site/shell/WordPressFool.tsx
// WordPress 伪装组件 - 欺骗 Wappalyzer 等技术检测工具

import { useEffect } from 'react';
import Script from 'next/script';

export function WordPressFool() {
  useEffect(() => {
    // 添加 WordPress 风格的 HTML 注释
    const yoastComment = document.createComment(
      ' This site is optimized with the Yoast SEO plugin v23.5 - https://yoast.com/wordpress/plugins/seo/ '
    );
    const wpComment = document.createComment(
      ' Performance optimized by W3 Total Cache. Served from: www.gracegrass.com '
    );
    document.head.insertBefore(yoastComment, document.head.firstChild);
    document.head.insertBefore(wpComment, document.head.firstChild);

    // 添加 WordPress generator meta
    const generatorMeta = document.createElement('meta');
    generatorMeta.name = 'generator';
    generatorMeta.content = 'WordPress 6.7.1';
    document.head.appendChild(generatorMeta);

    // 添加 WooCommerce generator (可选，让它看起来像电商站)
    const wooMeta = document.createElement('meta');
    wooMeta.name = 'generator';
    wooMeta.content = 'WooCommerce 9.5.1';
    document.head.appendChild(wooMeta);

    // 添加 WordPress pingback link
    const pingback = document.createElement('link');
    pingback.rel = 'pingback';
    pingback.href = 'https://www.gracegrass.com/xmlrpc.php';
    document.head.appendChild(pingback);

    // 添加 WordPress REST API 发现 link
    const restApi = document.createElement('link');
    restApi.rel = 'https://api.w.org/';
    restApi.href = 'https://www.gracegrass.com/wp-json/';
    document.head.appendChild(restApi);

    // 添加 WordPress shortlink
    const shortlink = document.createElement('link');
    shortlink.rel = 'shortlink';
    shortlink.href = 'https://www.gracegrass.com/?p=1';
    document.head.appendChild(shortlink);

    // 添加 DNS prefetch for WordPress
    const dnsPrefetch = document.createElement('link');
    dnsPrefetch.rel = 'dns-prefetch';
    dnsPrefetch.href = '//s.w.org';
    document.head.appendChild(dnsPrefetch);

    // 添加假的 wp-emoji 设置 (WordPress 特征)
    const emojiScript = document.createElement('script');
    emojiScript.type = 'text/javascript';
    emojiScript.textContent = `
      window._wpemojiSettings = {
        baseUrl: "https://s.w.org/images/core/emoji/15.0.3/72x72/",
        ext: ".png",
        svgUrl: "https://s.w.org/images/core/emoji/15.0.3/svg/",
        svgExt: ".svg",
        source: { concatemoji: "https://www.gracegrass.com/wp-includes/js/wp-emoji-release.min.js?ver=6.7.1" }
      };
    `;
    document.head.appendChild(emojiScript);

    // Cleanup function
    return () => {
      generatorMeta.remove();
      wooMeta.remove();
      pingback.remove();
      restApi.remove();
      shortlink.remove();
      dnsPrefetch.remove();
      emojiScript.remove();
    };
  }, []);

  return (
    <>
      {/* fooldevs JS 伪装 - 添加各种技术的全局变量来混淆检测 */}
      <Script
        src="https://cdn.jsdelivr.net/npm/fooldevs@latest"
        strategy="afterInteractive"
      />
      <Script id="fooldevs-init" strategy="afterInteractive">
        {`
          if (window.fooldevs) {
            // 启用多种技术伪装来混淆检测工具
            fooldevs.enable([
              fooldevs.modules.wordpress,   // WordPress CMS
              fooldevs.modules.jquery,      // jQuery (WordPress 常用)
              fooldevs.modules.googleAnalytics,
              fooldevs.modules.wix,         // 另一个 CMS
              fooldevs.modules.shopify,     // 电商平台
              fooldevs.modules.hubspot,     // 营销工具
              fooldevs.modules.zendesk,     // 客服工具
            ]);
          }
        `}
      </Script>

      {/* 假的 WordPress 样式表引用 (不会真正加载，因为是 print media) */}
      <link
        rel="stylesheet"
        id="flavor-theme-css"
        href="/wp-content/themes/flavor/style.css"
        media="print"
      />
      <link
        rel="stylesheet"
        id="flavor-theme-woocommerce-css"
        href="/wp-content/plugins/woocommerce/assets/css/woocommerce.css"
        media="print"
      />
    </>
  );
}
